/**
 * メッセージ画像（file_info_pub.status）の状態。
 *
 * ACTIVE   : 通常の状態。メッセージ作成画面の一覧に出す。
 * DISABLED : 一覧非表示。画像・設定は残したまま、新しく添付先として選べなくする。
 *
 * サーバーは添付できるかどうかをこの状態で判定していないため、
 * 「選ばせない」は一覧取得時の絞り込みで画面側が担保する。
 */
export class HtmlMailImageStatusConst {

	public static readonly ACTIVE = 'ACTIVE';
	public static readonly DISABLED = 'DISABLED';

	public static readonly LIST: Array<{ id: string; name: string }> = [
		{ id: HtmlMailImageStatusConst.ACTIVE, name: '表示中' },
		{ id: HtmlMailImageStatusConst.DISABLED, name: '一覧非表示' }
	];

	public static getName(status: string): string {
		const found = HtmlMailImageStatusConst.LIST.find(row => row.id === status);
		if (found) {
			return found.name;
		}
		return status;
	}

}
